import { useQuery } from '@apollo/client';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import ExpertEmployer from '@components/ExpertEmployer';
import HandleQuery from '@components/HandleQuery';
import AppPage from '@components/pageTypes/AppPage';
import {
  GetEmployerWithBenefitsDocument,
  GetEmployerWithBenefitsQuery,
  GetEmployerWithBenefitsQueryVariables
} from '@typing/Generated';

type Props = {
  employerId: string;
};

const ExpertJourneyEmployerPage = ({ employerId }: Props) => {
  const intl = useIntl();

  const getEmployerWithBenefitsQuery = useQuery<GetEmployerWithBenefitsQuery, GetEmployerWithBenefitsQueryVariables>(
    GetEmployerWithBenefitsDocument,
    {
      variables: { id: employerId }
    }
  );

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: 'pageTitles.expertJourney.employer.show' })}</title>
      </Helmet>
      <HandleQuery query={getEmployerWithBenefitsQuery}>
        {data => <ExpertEmployer employer={data.employer} />}
      </HandleQuery>
    </AppPage>
  );
};

export default ExpertJourneyEmployerPage;
